//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionTemplate from './SectionTemplate.vue';
export default {
  extends: SectionTemplate,
  data(){
    return {
        active: 0
    }
  },
  computed: {
    styleObject() {
      return {
        backgroundColor: this.data.background,
        backgroundImage: this.data.background_image ? 'url("'+this.data.background_image+'")' : 'none'
      };
    }
  },
  methods: {
    onCardClick(c){
      this.active = c;

      if(this.$route.params.slug === 'pricing'){
        window.location.assign(this.data.call_to_actions[c].button.url);
      }
    }
  }
}
